import React, { useRef } from 'react';
import styles from './Tables.module.scss';

import { Paper, Table, TableBody, TableContainer, TableHead, TableRow } from '@material-ui/core';

import { StyledTableCell, StyledTableRow } from 'components/StyledComponents';
import LinkComponent from 'components/LinkComponent/LinkComponent';
import TablePaginationRefactored from 'components/TablePaginationRefactored/TablePaginationRefactored';

import { LOCATION_DETAILED_PATH } from 'constants/routeConstants';
import { ASSET_VERIFICATION_HISTORY_TABLE_PARAMETER } from 'constants/configTableConstants';

import { dateTimeFormat, formatDate, getUserFullName } from 'helpers/AppHelpers';
import { getChangedByPageFilter } from 'helpers/SummaryPagesHelpers';

import { useMobileViewport } from 'hooks/useMobileViewport';
import { useUserConfig } from 'hooks/useUserConfig';
import { useAssetActions, useAssetSelector } from 'hooks/Asset';

import clsx from 'clsx';

export default function AssetVerificationHistory() {
  const isMobile = useMobileViewport();
  const tableRef = useRef(null);

  const { getTableLimit } = useUserConfig();

  const { verificationHistory, verificationHistoryFilter } = useAssetSelector();
  const { getVerificationHistory } = useAssetActions();

  const emptyResponse = () =>
    !verificationHistory?.items?.length &&
    verificationHistoryFilter?.pagination?.page === verificationHistory?.pageNumber;

  const changePage = (page, param) =>
    getVerificationHistory(getChangedByPageFilter(verificationHistoryFilter, page), param);

  const getUpdatedByLimitFilter = () => ({
    ...verificationHistoryFilter,
    pagination: {
      ...verificationHistoryFilter.pagination,
      page: 1,
      limit: getTableLimit(ASSET_VERIFICATION_HISTORY_TABLE_PARAMETER)
    },
    isDataReceived: false
  });

  return (
    <>
      <TableContainer className={clsx(styles.table, styles.verification)} component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Location</StyledTableCell>
              <StyledTableCell>Sublocation</StyledTableCell>
              <StyledTableCell>Last Verification</StyledTableCell>
              <StyledTableCell>Verified by</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {verificationHistory?.items?.length ? (
              verificationHistory.items.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell>
                    <LinkComponent
                      name={row.location?.siteCode || ''}
                      path={`${LOCATION_DETAILED_PATH}/${row.location?.id}`}
                      isRedirectAvailable={!row.location?.deleted}
                      boldText
                    />
                  </StyledTableCell>
                  <StyledTableCell>{row?.sublocation?.name || ''}</StyledTableCell>
                  <StyledTableCell>
                    {row['lastVerificationAtUtc']
                      ? formatDate(row['lastVerificationAtUtc'], dateTimeFormat)
                      : ''}
                  </StyledTableCell>
                  <StyledTableCell>{getUserFullName(row['verificatedByUser'])}</StyledTableCell>
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={10} className={styles.empty}>
                  No available data in the table.
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div className={styles.footer}>
        <TablePaginationRefactored
          isMobile={isMobile}
          rows={verificationHistory?.items?.length}
          currentPage={verificationHistoryFilter?.pagination?.page}
          totalPages={verificationHistoryFilter?.pagination?.totalPages}
          selectAllOption
          onPageSelect={changePage}
          pageLimit={verificationHistoryFilter?.pagination?.limit}
          hide={emptyResponse()}
          tableListParameter={ASSET_VERIFICATION_HISTORY_TABLE_PARAMETER}
          getTableData={() => getVerificationHistory(getUpdatedByLimitFilter())}
          tableRef={tableRef}
        />
      </div>
    </>
  );
}
